$(function(){
  setupHelpKeyboard();
});

function setupHelpKeyboard() {
  if($('.keyboard-help').hasClass('show')) $('.keyboard-help-hide').click(hide_keyboard);
  else $('.keyboard-help-hide').click(show_keyboard);
}

//hide keyboard in game
function hide_keyboard(){
    $('.keyboard-help').removeClass('show');
    $('.keyboard-help-hide').unbind('click')
      .click(show_keyboard);
    var hideBtn = $("#hidebtn", '#hiding-keyboard');
    hideBtn
      .text(hideBtn.attr('data-textShow'));
    $(".keyboard-help-hide>svg>use").attr('xlink:href',"#sipka_klavesnice_odkryti");

    $.post(baseUrl+'/player/save-keyboard-position', {'showKeyboard': 0});  // ajax, save the keyboard visibility
}

function hideKeyboardInner(translate){
    $(".keyboard-help").removeClass('show');
    $(".keyboard-help-hide").unbind("click")
      .css({transform: 'translateY(' + translate + 'px)'})
      .click(show_keyboard);
}

//show keyboard in game
function show_keyboard(){
    $(".keyboard-help").addClass('show');
    var hideBtn = $("#hidebtn", '#hiding-keyboard');
    hideBtn
      .text(hideBtn.attr('data-textHide'));
    $(".keyboard-help-hide").unbind("click")
      .click(hide_keyboard);
    $(".keyboard-help-hide>svg>use").attr('xlink:href',"#sipka_klavesnice_skryti");
    
    $.post(baseUrl+'/player/save-keyboard-position', {'showKeyboard': 1});  // ajax, save the keyboard visibility
}
